export default __webpack_public_path__ + "images/0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f.png";